<div *ngIf="gallery" [id]="slideType" class="gallery-top" [ngClass]="{'overflow': slideType=='leaderboard'}">
  <div class="content">
    <ngx-glide [animationTimingFunc]="'ease-in-out'"
              [showArrows]="isMobile && gallery?.length > 1 ? true : false"
              [showBullets]="false"
              [hoverpause]="true"
              [animationDuration]="250"
              [startAt]="currentIndex"
              [perView]="1"
              [autoplay]="autoSlide ? 3000 : false"
              [listenToEvents]="true"
              [arrowLeftLabel]="''"
              [arrowRightLabel]="''"
              (ranAfter)="getIndex($event)"
            >
      <div [id]="'lightgallery' + slideType" class="" *ngFor="let slide of gallery; let i = index;">
        <a [href]="slideType=='leaderboard'? domSanitizer.bypassSecurityTrustResourceUrl('javascript:void(0)') :slide.cdn_path"
        [attr.data-sub-html]="slide?.detail_1" class="swiper-slide img-container">
        <!-- For images -->
        <img loading="lazy" [hidden]="slide.media_type==='video'" class="img" [ngClass]="slideType" src="/assets/images/transparent.png" [attr.data-src]="slide.cdn_path" defaultImg="blur" [alt]="'Fundraiser Leaderboard'+i" />
        <!-- For Youtube video -->
        <img loading="lazy" [hidden]="!(slide.media_type=='video' && !slide?.showVideo)" class="img"
        [ngClass]="slideType" [attr.data-src]="slide.cdn_path" (click)="addYoutubeEmbed(slide)"
        [alt]="'Fundraiser Leaderboard Youtube Video'+i" />
        <i *ngIf="slide.media_type=='video' && !slide?.showVideo" class="icon-youtube1"
        (click)="addYoutubeEmbed(slide)"></i>
        <!-- Youtube embed -->
        <iframe *ngIf="slide.media_type=='video' && slide?.showVideo" class="youtube-embed b-lazy" [ngClass]="slideType" type="text/html" allow="autoplay" [src]="slide?.videoSrc"></iframe>
        <!-- Under line shadow -->
        <div *ngIf="shadow" class="image-shadow" [ngClass]="{'videos': slide.media_type === 'video'}" [attr.data-bg]="slide.cdn_path"></div>
        <!-- Fundraiser Short Description for desktop-->
        <div class="fr-short-description" *ngIf="!isMobile && basicInfo && !slide?.showVideo">{{basicInfo?.about}}</div>
      </a>
    </div>
  </ngx-glide>
    <span class="ketto-verified-fos" *ngIf="isFOS">
      <app-ketto-assured></app-ketto-assured>
      <!-- <img loading="lazy" data-src="/assets/images/ketto-verifiedTag.png" alt="ketto verified image badge"> -->
    </span>
  </div>
</div>
<div class="thumbnail-area" *ngIf="hasThumbs">
  <div class="thumbs-container">
    <div class="glide-container gallery-thumbs" *ngIf="!isMobile && gallery && gallery?.length>1">
      <div class="glide-wrapper">
        <ngx-glide [showArrows]="gallery?.length > 3 ? true : false" [arrowLeftLabel]="''" [arrowRightLabel]="''" [showBullets]="false"
          [autoplay]="false" [perView]="4.3" [startAt]="currentIndex > 3 ? currentIndex - 3 : 0">
          <div class="card-widget" *ngFor="let slide of gallery; let i = index">
            <img loading="lazy" class="img" [src]="slide?.cdn_path" [ngClass]="{'active-thumb': i === currentIndex }" (click)="thumbsOnClick(i)" [alt]="'Fundraiser Leaderboard Thumbnails'+i" />
          </div>
        </ngx-glide>
      </div>
    </div>
  </div>
  <div class="share-fundraiser-container d-none d-sm-inline-block" *ngIf="hasThumbs">
    <!-- Socail Share -->
    <app-social-share shareType="menu" *ngIf="share"></app-social-share>
  </div>
</div>